import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Crud, CrudService, CustomHttp, ConfigServerService } from '../../../core';
import { Meta } from '../meta';
import { MetaFilterSearch } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class MetaCrudHttpService implements Crud<Meta> {
    resource = 'meta';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa as metas */
    search(): Observable<Meta[]> {
        return this.crudService.search<Meta>(this.resource);
    }

    /** Pesquisa as metas */
    searchWithFilter(filter: MetaFilterSearch): Observable<Meta[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }
        return this.crudService.search<Meta>(this.resource, {params});
    }

    /** Procura uma única meta através do seu ID */
    find(id: number): Observable<Meta> {
        return this.crudService.find<Meta>(this.resource, id);
    }

    /** Carrega uma única meta através do seu ID */
    load(id: number): Observable<Meta> {
        return this.crudService.load<Meta>(this.resource, id);
    }

    /** Insere uma nova meta */
    insert(entity: Meta): Observable<Meta> {
        return this.crudService.insert<Meta>(this.resource, entity);
    }

    /** Altera uma meta existente */
    update(entity: Meta): Observable<Meta> {
        return this.crudService.update<Meta>(this.resource, entity);
    }

    /** Exclui uma meta através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
